import $ from 'jquery';
localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ? import('@/app/visit-management/theme/discountrule.scss') : import('@/app/visit-management/theme/discountrule-rtl.scss');
import localeEn from '@/app/visit-management/locales/en.json'
import localeAr from '@/app/visit-management/locales/ar.json'
import { mapGetters } from 'vuex';

import { noRecordTemplate, showPopupNotification } from '@/app/shared/grid-functionality/grid-functionality.js';
import config from '@/app/visit-management/shared/config/vm-config.json';
import { EventBus as GlobalEventBus} from '@/app/shared/services/event-bus.js';
import {
    getVisitClaimNphiesStatus, getReloadStatementResult, getCancelRequestEnums, 
    getSendStatementsToNphiesResult, getMarkStatementToCancelResult
} from '@/app/visit-management/shared/visitManagement-enums.js';
import { SortableKendoService } from '@/app/shared/services/kendo-service/kendoService.js';
import { contractorStatementService } from '@/app/visit-management/services/contractor-statement-service.js';
import { refreshGrid } from '@/app/shared/grid-functionality/grid-utilities.js';
import { modelServices } from '@/app/shared/services/client-agent-service.js';

export default {
    name: 'contractor-bulk-actions-grid',
    props: ['StatementStatusObj', 'VisitNphiesStatus'],
    data() {
        return {
            gridFiltered: false,
           
            renderGrid: true,
            suffix: 'contractor-bulk-actions-grid',
            
            isLoading: false,
            loadingCount: 0,
            hideNotification: 5000,
            ContractorStatementID: this.$route.query.ContractorStatementID,
            SelectedVisitIds: [],
            statementId: null,
            ModifiedTS: '',
            hasSendToNphiesPermission: this.showHideElement("CanSendStatement"),
            hasSendClaimRequestPermission: this.showHideElement("SendClaimRequestToNPHIES"),
            hasSingleCancelClaimRequestPermission: this.showHideElement("SingleCancelClaimRequest"),
            hasBulkCancelClaimRequestPermission: this.showHideElement("BulkCancelClaimRequest"),
            // In Case the grid has no record show the shared template 
            noRecordTemplate: noRecordTemplate,
            defaultEmptyFieldValue: '-',
            
            statementsVisitsGridSchema: {
                VisitID: { type: "number" },
                StatementID: { type: "number" },
                ContractorClientArName: { type: "string" },
                ContractorClientEnName: { type: "string" },
                StatementStatusID: { type: "number" },
                StatementStatusArName: { type: "string" },
                StatementStatusEnName: { type: "string" },
                NphiesStatusId: { type: "number" },
                VisitNphiesStatusArName: { type: "string" },
                VisitNphiesStatusEnName: { type: "string" },
                VisitNphiesStatusFontColor: { type: "string" },
                VisitNphiesStatusBackgroundColor: { type: "string" },
                VisitClassificationEnName: { type: "string" },
                VisitClassificationArName: { type: "string" },
                PatientCode: { type: "string" },
                PatientArName: { type: "string" },
                PatientEnName: { type: "string" },
                LastRequestBundleId: { type: "string" },
                TotalIShare: { type: "number" }

            },
            selectedDataObj: {},
            confirmdata: [
                {
                    id: 0,
                    confirmText: '',
                    confirmBtnBtnText: '',
                    cancelBtnText: '',
                    headerTitle: '',
                    messageText: '',
                    poptype: '',
                    itemName: '',
                    qmark: '',
                    ModifiedTS: ''
                }
            ],
            pageableObject: {
                pageSizes: [5, 10, 20, 50, 100],
                buttonCount: 5,
                pageSize: config.pageSize
            },
            parentColumns: [
                {
                    title: '',
                    width: '6px',
                    attributes: {
                        "class": "statusBulkClass"
                    },
                    template: function (item) {

                        let claimStatusColor = 'transperent';
                        if (item.StatementStatusColorCode != '' && item.StatementStatusColorCode != null)
                            claimStatusColor = item.StatementStatusColorCode;

                        return `<div class='statusHolderBG tdClass' style='background-color:${claimStatusColor}'> </div>`;
                    },
                    filterable: false,
                    sortable: false
                },              
                {
                    field: 'ContractorClientName',
                    title: this.$i18n.t('vm.Nphies.ContractorStatement.CodeContractorClient'),
                    template: (item) => {
                        let that = this;
                        return '<div class="tdTrimClass">' + that.getDefaultValueifNull(item.ContractorClientName) + '</div>';
                    },
                    filterable: {
                        cell: {
                            showOperators: "false",
                            operator: "contains",
                            suggestionOperator: "contains",
                        }
                    },                    
                    sortable: true,
                    width: '150px',

                },
                {
                    field: 'VisitClassificationName',
                    title: this.$i18n.t('vm.Nphies.ContractorStatement.VisitCategory'),
                    template: (item) => {
                        let that = this;
                        return '<div class="tdTrimClass">' + that.getDefaultValueifNull(item.VisitClassificationName) + '</div>';
                    },
                    filterable: {
                        cell: {
                            showOperators: "false",
                            operator: "contains",
                            suggestionOperator: "contains",
                        }
                    },
                    sortable: true,
                    width: '150px',
                },
                {
                    field: 'VisitID',
                    title: this.$i18n.t('vm.Nphies.ContractorStatement.VisitID'),
                    template: (item) => {
                        let that = this;
                        return '<div class="tdTrimClass">' + that.getDefaultValueifNull(item.VisitID) + '</div>';
                    },
                    filterable: {
                        cell: {
                            showOperators: "false",
                            operator: "eq",
                            suggestionOperator: "eq",                           
                        }
                    },
                    sortable: true,
                    width: '100px',
                },
                {
                    field: 'PatientCode',
                    title: this.$i18n.t('vm.Nphies.ContractorStatement.PatientCode'),
                    template: (item) => {
                        let that = this;
                        return '<div class="tdTrimClass">' + that.getDefaultValueifNull(item.PatientCode) + '</div>';
                    },
                    filterable: {
                        cell: {
                            showOperators: "false",
                            operator: "contains",
                            suggestionOperator: "contains",
                        }
                    },
                    sortable: true,
                    width: '140px',
                },
                {
                    field: 'PatientName',
                    title: this.$i18n.t('vm.Nphies.ContractorStatement.PatientName'),
                    template: (item) => {
                        let that = this;
                        return '<div class="tdTrimClass">' + that.getDefaultValueifNull(item.PatientName) + '</div>';
                    },
                    filterable: {
                        cell: {
                            showOperators: "false",
                            operator: "contains",
                            suggestionOperator: "contains",
                        }
                    },
                    sortable: true,
                    width: '150px',
                },
                {
                    field: 'TotalIShare',
                    title: this.$i18n.t('vm.Nphies.ContractorStatement.TotalIShare'),
                    template: (item) => {
                        let that = this;
                        return '<div class="tdClass">' + that.getDefaultValueifNull(item.TotalIShare) + '</div>';
                    },
                    filterable: {
                        cell: {
                            showOperators: "false",
                            operator: "eq",
                            suggestionOperator: "eq",
                        }
                    },
                    sortable: true,
                    width: '120px',
                },
                {
                    field: 'LastRequestBundleId',
                    title: this.$i18n.t('vm.Nphies.ContractorStatement.BundleID'),
                    template: (item) => {
                        debugger;
                        let that = this;
                        return '<div class="tdTrimClass">' + that.getDefaultValueifNull(item.LastRequestBundleId) + '</div>';
                    },
                    filterable: {
                        cell: {
                            showOperators: "false",
                            operator: "contains",
                            suggestionOperator: "contains",
                        }
                    },
                    sortable: true,
                    width: '150px',
                },
                {
                    field: 'VisitNphiesStatusName',
                    title: this.$i18n.t('vm.Nphies.ContractorStatement.Status'),
                    template: function (item) {
                        let color = 'transperent';
                        let backgroundColor = 'transperent';
                        if (item.VisitNphiesStatusFontColor != '' && item.VisitNphiesStatusFontColor != null)
                            color = item.VisitNphiesStatusFontColor;
                        if (item.VisitNphiesStatusBackgroundColor != '' && item.VisitNphiesStatusBackgroundColor != null)
                            backgroundColor = item.VisitNphiesStatusBackgroundColor;
                        return `<div class='statusHolder tdClass' style='color:${color};background-color:${backgroundColor}'>  ${item.VisitNphiesStatusName}  </div> `;
                    },
                    width: '170px',                    
                    filterable: false,
                    sortable: true
                },
                {
                    title: '',
                    width: '50px',
                    template: (dataItem) => {
                        console.log(dataItem, 'errorlist')
                        return (dataItem.NphiesStatusId == getVisitClaimNphiesStatus().Invalid ||
                            dataItem.NphiesStatusId == getVisitClaimNphiesStatus().ErrorInResponse) ?
                            `<a id="errorListId" class="errorIClass"><img src=${require('@/assets/svg/vm/errorIcon.svg')} / > </a>` : '';
                    },
                    filterable: false,
                    sortable: false
                },
                {
                    field: 'Actions',
                    title: this.$i18n.t('Common.Actions'),
                    width: '80px',
                    filterable: false,
                    sortable: false,
                    template: this.showListMenu
                },
            ],
           
            bulkActionsGridDS: (!this.SelectedStatementIds && !this.SelectedNphiesStatusIds) ?
                {
                    schema: this.statementsVisitsGridSchema,
                    data: []
                } :
                this.getStatementsVisits(this.SelectedStatementIds, this.SelectedNphiesStatusIds, null, this.ContractorStatementID).data,
            //bulkActionsGridDS: [

            //    {              
            //        CanCancelNphiesClaimRequest: true,
            //        CanSendSingleClaimRequest: true,
            //        ContractorClientArName: "",
            //        ContractorClientEnName: "",
            //        ContractorClientName: "",
            //        LastRequestBundleId: "87852191-32a6-4e65-b601-ed5da48222de",
            //        NphiesStatusI: 1,
            //        PatientArName: "دعاء تيست براتيل فرحه",
            //        PatientCode: "00159235",
            //        PatientEnName: "Doaa Test Partial FOUR",
            //        PatientName: "Doaa Test Partial FOUR",
            //        StatementID: 2079,
            //        StatementStatusArName: "جديدة",
            //        StatementStatusColorCode: "#86e2d6",
            //        StatementStatusEnName: "New",
            //        StatementStatusID: 1,
            //        StatementStatusName: "New",
            //        TotalIShare: 903.6,
            //        VisitClassificationArName: "عيادات خارجية",
            //        VisitClassificationEnName: "Outpatient",
            //        VisitClassificationName: "Outpatient",
            //        VisitID: 381406,
            //        VisitNphiesStatusArName:"Queued in HIC",
            //        VisitNphiesStatusBackgroundColor:"#E1A765",
            //        VisitNphiesStatusEnName:"Queued in HIC",
            //        VisitNphiesStatusFontColor: "#FFFFFF",
            //        VisitNphiesStatusName: "Queued in HIC",
            //        NphiesStatusId:1
            //    }
            //],
            appliedFilter: {
                statements: [],
                statementStatusIDs: [],
                isBundleIDApplied: false,
                visitNphiesStatusIDs: []
            }
             
        }
    },
    computed: {
        ...mapGetters(['getSelectedStatementStatusIDs', 'getIsBundleIDFilterApplied', 'getSelectedStatements',
            'getContractorClientsDS']),

        statusItems() {
            if (!this.StatementStatusObj)
                return;

            return this.StatementStatusObj.StatementStatuses
        },
        ConfirmedMsg() {
            return this.$i18n.t('vm.Nphies.ContractorStatement.CancelMessageText');
        },
        SelectedStatementIds() {
            debugger;
            return this.$store.getters.getSelectedStatementIds;
        },

        SelectedNphiesStatusIds() {
            debugger;
            return this.$store.getters.getSelectedNphiesStatusIds;

        },
        isBulkSendFilterDataIncomplete() {
            return this.StatementStatusObj == null || this.appliedFilter.isBundleIDApplied
        },
        isBulkSendToNphiesAllowed() {
            return this.appliedFilter.statementStatusIDs.length > 0 &&
                this.appliedFilter.statementStatusIDs.every(id => this.StatementStatusObj.AllowedSendClaimsIDs.includes(id));
        },
        isBulkSendToNphiesDisabled() {
            return this.isBulkSendFilterDataIncomplete || (this.isBulkSendToNphiesAllowed == false) || this.gridFiltered
        },
        isBulkSendToNphiesTooltipDisabled() {
            return (this.isBulkSendToNphiesDisabled == false) || this.isBulkSendFilterDataIncomplete;
        },
        isBulkCancelActionAllowed() {
            if (this.StatementStatusObj == null || this.appliedFilter.isBundleIDApplied || this.gridFiltered)
                return false;

            return this.appliedFilter.statementStatusIDs.length > 0;
        },
        tooltipSendClaimDisabledText() {
            if (this.isBulkSendToNphiesAllowed == false) {
                return this.$i18n.t('vm.Nphies.ContractorStatement.SingleSendClaimDisabled');
            }
            else if (this.gridFiltered) {
                return this.$i18n.t('vm.Nphies.ContractorStatement.sendFilteredMessageText');
            }
        },
        tooltipCancelActionAllowedText() { 
             if (this.gridFiltered) {
                 return this.$i18n.t('vm.Nphies.ContractorStatement.cancelFilteredMessageText');
            }
        },
        isBulkCancelActionAllowedTooltipDisabled() {
            return (this.gridFiltered == false) ;
        },
    },
    methods: {
        showPopupNotification,
        showHideElement(clientAction) {
            return modelServices.ifUserHasPermission(clientAction, this.$route.name);
        },
        setIsLoading(isLoading) {
            GlobalEventBus.$emit("setIsLoading", isLoading)
        },
        forceRerenderGrid() {
            // Remove my-component from the DOM
            this.renderGrid = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderGrid = true;
            });
        },
        // Add Tooltip
        getTooltipTilte: function (e) {
            document.querySelectorAll('[role="tooltip"]').forEach(tooltipDiv => {
                tooltipDiv.style.visibility = 'hidden'
            });
            let elem = e.target[0];

            if ((elem.offsetWidth < elem.scrollWidth) || (elem.classList.contains("tdClass") && (elem.offsetWidth < elem.scrollWidth)) || (elem.classList.contains("k-button"))) {
                $('[role="tooltip"]').css("visibility", "visible");

                return e.target.text();
            }
            // view tooltip on Blocked Icon
            else if (elem.classList.contains("disabledSendClick")) {
                $('[role="tooltip"]').css("visibility", "visible");
                return `${this.$i18n.t('vm.Nphies.ContractorStatement.SingleSendClaimDisabled')}`
            }
            else {
                $('[role="tooltip"]').css("visibility", "hidden");
                return ""
            }
        },
        // Confirm Popup
        showConfirmPopup(e, actionName) {
            debugger;
            let item = {};
            if (actionName == getCancelRequestEnums().SingleCancelRequest) {
                var closestGridElement = $(e.target).closest("tr").closest('[data-role="grid"]');
                var id = closestGridElement.attr('id');
                console.log(id);
                var tr = $(e.target).closest("tr")
                let grid = $('#' + id).getKendoGrid();

                item = grid.dataItem(tr);
            }

            this._bv__modal.show('modal-scoped' + this.suffix)
            this.confirmdata.poptype = "danger";
            this.confirmdata.iconName = 'text-danger fas fa-exclamation-triangle';
            this.confirmdata.headerTitle = this.$i18n.t('Common.Alert');
            this.confirmdata.confirmBtnText = this.$i18n.t('Common.No');
            this.confirmdata.cancelBtnText = this.$i18n.t('Common.Yes');
            this.confirmdata.messageText = (actionName == getCancelRequestEnums().SingleCancelRequest) ? this.$i18n.t('vm.Nphies.ContractorStatement.SingleCancelMessageText') : actionName == getCancelRequestEnums().BulkCancelRequest ? this.$i18n.t('vm.Nphies.ContractorStatement.BulkCancelMessageText') : '';//this.ConfirmedMsg;
            this.confirmdata.id = item.id;
            //   this.confirmdata.modifiedTs = item.modifiedTS;
            this.confirmdata.actionName = actionName;

        },
       
        onDataBound(e) {
            
            if ($("#bulkActionsGridId").data("kendoGrid").dataSource.filter()) {
                this.gridFiltered = true;
            }
            else {
                this.gridFiltered = false;
            }
            console.log(e)
            $('#bulkActionsGridId .k-pager-wrap').removeClass("k-pager-lg");
            $('#bulkActionsGridId .k-pager-wrap').removeClass("k-pager-sm");
            $(".k-filtercell [data-role='autocomplete']").attr('placeholder', '');
            $(".k-filtercell [data-role='numerictextbox']").attr('placeholder', '');
             $('.sendNphiesClass').click(this.clickSendRequestToNphies);
            $('.viewHClass').click(this.clickViewHistory);
            $('.errorIClass').click(this.clickTransactionErrorList);
           
            $('.cancelBtnClass').click(this.cancelClaimRequestClick);
           
           
        },
        //Get Selected Item
        getSelectedItem(e) {
            let closestGridElement = $(e.target).closest("tr").closest('[data-role="grid"]');
            let id = closestGridElement.attr('id');
            let tr = $(e.target).closest("tr")
            let grid = $('#' + id).getKendoGrid();

            return grid.dataItem(tr);
        },

        clickViewHistory(e) {
            debugger;
            this.selectedDataObj = this.getSelectedItem(e);
            console.log(this.selectedDataObj, 'selectedDataObj')

            this._bv__modal.show('view-history-modal-id');

        },

        clickTransactionErrorList(e) {
            debugger;
            this.selectedDataObj = this.getSelectedItem(e);
            console.log(this.selectedDataObj, 'selectedDataObj')

            this._bv__modal.show('transaction-error-list-modal-id');

        },

        getSendClaimRequestByStatement() {
            this.setIsLoading(true);
            contractorStatementService.SendClaimRequestByStatement(this.SelectedVisitIds,this.statementId, this.ModifiedTS, (result) => {
                if (result) {
                    if (result.data) {
                        console.log(result.data, 'result.data')
                        switch (result.data) {
                            case parseInt(getReloadStatementResult().Success):
                                this.showPopupNotification(`${this.$i18n.t('Common.Success')}`, `${this.$i18n.t('Common.SentSuccessfully')}`, `success`);
                                refreshGrid("#bulkActionsGridId");
                                break;

                            case parseInt(getReloadStatementResult().Concurrency):
                                this.showPopupNotification(`${this.$i18n.t('Common.Warning')}`, `${this.$i18n.t('Common.Concurrency')}`, `warning`);
                                refreshGrid("#bulkActionsGridId");
                                break;

                            case parseInt(getReloadStatementResult().Failure):
                                this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('Common.SomethingWrong')}`, 'error');
                                refreshGrid("#bulkActionsGridId");
                                break;
                        }

                    }
                    else {
                        this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('Common.SomethingWrong')}`, 'error');
                    }
                }

                this.setIsLoading(false);
            },
                (error) => {
                    this.setIsLoading(false);
                    console.error(error, "error");
                });
        },

        confirmSingleCancelNphiesRequest() {
            this.setIsLoading(true);
            contractorStatementService.SingleCancelClaimRequest({ StatementId: this.statementId, VisitIds: [this.SelectedVisitIds] }, (response) => {
                if (response) {
                    debugger
                    if (response.data.Result) {
                        console.log(response.data, 'result.data')
                        switch (response.data.Result) {
                            case parseInt(getReloadStatementResult().Success): //1
                                this.showPopupNotification(`${this.$i18n.t('Common.Success')}`, `${this.$i18n.t('vm.Nphies.ContractorStatement.CanceledSuccessfully')}`, `success`);
                                refreshGrid("#bulkActionsGridId");
                                break;


                            case parseInt(getReloadStatementResult().Failure): //2
                                if (response.data.ErrorList != null) {

                                    this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, response.data.ErrorList[0], 'error');

                                } else {

                                    this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('Common.SomethingWrong')}`, 'error');

                                }
                                refreshGrid("#bulkActionsGridId");
                                break;


                            case parseInt(getReloadStatementResult().Concurrency): //3
                                this.showPopupNotification(`${this.$i18n.t('Common.Warning')}`, `${this.$i18n.t('Common.Concurrency')}`, `warning`);
                                refreshGrid("#bulkActionsGridId");
                                break;

                        }

                    }
                    else {
                        this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('Common.SomethingWrong')}`, 'error');
                    }
                }

                this.setIsLoading(false);
            },
                (error) => {
                    this.setIsLoading(false);
                    console.error(error, "error");
                });
        },

        clickSendRequestToNphies(e) {
            this.selectedDataObj = this.getSelectedItem(e);
            console.log(this.selectedDataObj, 'selectedDataObj')
            // this.statementId = this.selectedDataObj.StatementID;
            //   this.SelectedVisitIds = this.selectedDataObj.VisitID;
            //  this.ModifiedTS = '';
            this.$bvModal.show('send-claim-request-nphies-id');
            //this.getSendClaimRequestByStatement();

        },

        cancelClaimRequestClick(e) {
            this.selectedDataObj = this.getSelectedItem(e);
            console.log(this.selectedDataObj, 'selectedDataObj')
            this.statementId = this.selectedDataObj.StatementID;
            this.SelectedVisitIds = this.selectedDataObj.VisitID;

            this.$bvModal.show('cancel-claim-request-id');

        },
        getDefaultValueifNull(val) {
            return val == null || val == "" ? this.defaultEmptyFieldValue : val;
        },
        showListMenu: function (dataItem) {
            let SendClaimRequestDisabled = !dataItem.CanSendSingleClaimRequest;
            let SendToNphiesDisabled = this.getStatusByNphiesStatusId(dataItem.NphiesStatusId).IsNphiesClaimDisallowed;
           // let SendToNphiesDisabled = false;
            let menu = `
                    <div class='dropdown conmyDropDown'>
                      <button class='dropdown-toggle menu dots menuSelectAll' type='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>
                            <span class='fas fa-ellipsis-v fa-menu cursor-pointer px-2 menuSelectAll'></span>
                      </button>
                        <div class='dropdown-menu dropdownMenuList' aria-labelledby='dropdownMenuButton'>
                            <div class="dropdownItemClass">
                                <ul>
                                    <li id="viewHistoryId" class="viewHClass"><a><img src=${require('@/assets/svg/vm/ViewMenu.svg')} / > ${this.$i18n.t("vm.Nphies.ContractorStatement.ViewHistory")}</a></li>
                                    ${(this.hasSendClaimRequestPermission) ? `<li id="sendNphiesBtnId" ><a role='button' class='sendNphiesClass ${SendClaimRequestDisabled ? 'disabledSendClick' : ''} ${SendToNphiesDisabled ? 'disabledSendToNphiesClick' : ''}' ${(SendClaimRequestDisabled || SendToNphiesDisabled) ? 'disabled' : ''}>  <img src=${(SendClaimRequestDisabled || SendToNphiesDisabled) ? require('@/assets/svg/vm/sendToNphiesDisabled.svg') : require('@/assets/svg/vm/sendToNphiesMenu.svg')} / > ${this.$i18n.t("vm.Nphies.ContractorStatement.SendToNphies")}</a></li>` : ''}
                                   ${(this.hasSingleCancelClaimRequestPermission && dataItem.CanCancelNphiesClaimRequest) ? `<li id="cancelBtnId" class="cancelBtnClass"><a><img src=${require('@/assets/svg/vm/cancelMenu.svg')} / >  ${this.$i18n.t("vm.Nphies.ContractorStatement.CancelClaimRequest")}</a></li>` : ''}
                                </ul>
                            </div>
                        </div>
                    </div>`;
            return menu;
        },
        getStatusByNphiesStatusId(nphiesStatusId) {
            return this.VisitNphiesStatus.filter(item => item.StatusId == nphiesStatusId)[0];
        },
        getStatementsVisits(statementIds, nphiesStatusIds, bundleId, contractorStatementID) {
            
            return new SortableKendoService(contractorStatementService.GetStatementVisitsODataURL(statementIds,
                nphiesStatusIds, bundleId,contractorStatementID),
                config.pageSize, "VisitID", this.statementsVisitsGridSchema, "", true, "desc", {});
            
        },       
        onBulkSendToNphiesClick() {
            let statements = this.appliedFilter.statements.map(statement => ({
                ID: statement.StatementID,
                ModifiedTS: statement.ModifiedTS
            }));

            let inputModel = {
                Statements: statements,
                VisitNphiesStatusIDs: this.appliedFilter.visitNphiesStatusIDs
            };

            this.setIsLoading(true);

            contractorStatementService.SendStatementsToNphies(inputModel,
                (result) => {
                    this.handleSendStatementsToNphiesResponse(result);
                },
                (error) => {
                    this.setIsLoading(false);

                    console.error(error, "On Bulk Send To Nphies Click");
                });
        },
        handleSendStatementsToNphiesResponse(response) {
            if (response?.data == null) {
                this.setIsLoading(false);
                return;
            }
            
            switch (response.data.Result) {
                case getSendStatementsToNphiesResult().Success:
                    //Success
                    this.showPopupNotification(`${this.$i18n.t('Common.Success')}`, `${this.$i18n.t('Common.SentSuccessfully')}`, `success`);

                    this.updateContractorClientsModifiedTS(response.data.Statements);
                    break;

                case getSendStatementsToNphiesResult().HasInProgressRecords:
                    //Success, but some records were not updated because they are In Progress (Being processed by the Claim Job)
                    this.showPopupNotification(`${this.$i18n.t('Common.Warning')}`, `${this.$i18n.t('vm.Nphies.ContractorStatement.InProgressNotUpdated')}`, `warning`);

                    this.updateContractorClientsModifiedTS(response.data.Statements);
                    break;

                case getSendStatementsToNphiesResult().Failure:
                    //Failure
                    this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, response.data.ErrorMessage ?? `${this.$i18n.t('Common.SomethingWrong')}`, 'error');
                    break;

                case getSendStatementsToNphiesResult().Concurrency:
                case getSendStatementsToNphiesResult().InvalidStatementByConfiguration:
                    //Concurrency
                    this.showPopupNotification(`${this.$i18n.t('Common.Warning')}`, `${this.$i18n.t('Common.Concurrency')}`, `warning`);
                    break;

                case getSendStatementsToNphiesResult().FlagIsEmpty:
                    this.showPopupNotification(`${this.$i18n.t('Common.Warning')}`, `${this.$i18n.t('vm.Nphies.ContractorStatement.NoDisplayRecordToSend')}`, `warning`);
                    break;
            }

            this.setIsLoading(false);
        },
        updateContractorClientsModifiedTS(statements) {
            // Update ModifiedTS in ContractorClients with the values from statements
            this.updateStatementsModifiedTS(this.getContractorClientsDS, statements);
            this.updateStatementsModifiedTS(this.getSelectedStatements, statements);
        },
        updateStatementsModifiedTS(statementsToUpdate, updatedStatements) {
            statementsToUpdate.forEach(statementToUpdate => {
                const matchingStatement = updatedStatements.find(updatedStatement => updatedStatement.ID === statementToUpdate.StatementID);

                if (matchingStatement) {
                    statementToUpdate.ModifiedTS = matchingStatement.ModifiedTS;
                }
            });
        },
        onBulkCancelRequestClick(e) {
                this.showConfirmPopup(e, getCancelRequestEnums().BulkCancelRequest)
        },
        bulkCancelRequest() {
            let statements = this.appliedFilter.statements.map(statement => ({
                ID: statement.StatementID,
                ModifiedTS: statement.ModifiedTS
            }));

            let inputModel = {
                Statements: statements,
                VisitNphiesStatusIDs: this.appliedFilter.visitNphiesStatusIDs
            };

            this.setIsLoading(true);

            contractorStatementService.MarkStatementToCancel(inputModel,
                (result) => {
                    this.handleMarkStatementToCancelResponse(result);
                },
                (error) => {
                    this.setIsLoading(false);

                    console.error(error, "On Bulk Cancel Request");
                });
        },
        handleMarkStatementToCancelResponse(response) {
            if (response?.data == null) {
                this.setIsLoading(false);
                return;
            }

            switch (response.data.Result) {
                case getMarkStatementToCancelResult().Success:
                    //Success
                    this.showPopupNotification(`${this.$i18n.t('Common.Success')}`, `${this.$i18n.t('vm.Nphies.ContractorStatement.CanceledSuccessfully')}`, `success`);

                    this.updateContractorClientsModifiedTS(response.data.Statements);
                    break;

                case getMarkStatementToCancelResult().HasInProgressRecords:
                    //Success, but some records were not updated because they are In Progress (Being processed by the Claim Job)
                    this.showPopupNotification(`${this.$i18n.t('Common.Warning')}`, `${this.$i18n.t('vm.Nphies.ContractorStatement.InProgressNotUpdated')}`, `warning`);

                    this.updateContractorClientsModifiedTS(response.data.Statements);
                    break;

                case getMarkStatementToCancelResult().Failure:
                    //Failure
                    this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, response.data.ErrorMessage ?? `${this.$i18n.t('Common.SomethingWrong')}`, 'error');
                    break;

                case getMarkStatementToCancelResult().Concurrency:
                    //Concurrency
                    this.showPopupNotification(`${this.$i18n.t('Common.Warning')}`, `${this.$i18n.t('Common.Concurrency')}`, `warning`);
                    break;
            }

            this.setIsLoading(false);
        },
        //To change icon in popup
        IconSource() {
            if (this.isBulkSendToNphiesAllowed) {
                return `${require("@/assets/svg/vm/sendToNphies.svg")}`;
            }
            else {
                return `${require("@/assets/svg/vm/sendToNphiesDisabled.svg")}`;
            }
        },
        CanceledClaimHandler(/*eventArgs*/) {
            refreshGrid("#bulkActionsGridId");
        }
    },
    mounted() {
        
        this.popupNotificationWidget = this.$refs.popupNotificationSave.kendoWidget();

        $("body").on("click", ".menu", function () {

            let hasClass = $(this).closest(".dropdown.conmyDropDown").find('.dropdown-menu.dropdownMenuList').hasClass('show');
            if (hasClass) {
                $(this).closest(".dropdown.conmyDropDown").find('.dropdown-menu.dropdownMenuList').removeClass('show');
            } else {
                $(".dropdown-menu.dropdownMenuList").removeClass("show");
                $(this).closest(".dropdown.conmyDropDown").find('.dropdown-menu.dropdownMenuList').addClass('show');
            }

        });

        $(document).on("click", "body", function (e) {
            if (!($(e.target).hasClass('menuSelectAll'))) $(".dropdown-menu.dropdownMenuList").removeClass("show");

        });
        GlobalEventBus.$on(`confirmed-action${this.suffix}`, (data) => {
            let that = this;           
            if (data.actionName == getCancelRequestEnums().SingleCancelRequest) {
                that.confirmSingleCancelNphiesRequest()
            }
            else if (data.actionName == getCancelRequestEnums().BulkCancelRequest) {
                this.bulkCancelRequest();
            }
            this._bv__modal.hide('modal-scoped');
        });
        GlobalEventBus.$on(`GetStatementsVisits`, (obj) => {

            this.appliedFilter = {
                isBundleIDApplied: this.getIsBundleIDFilterApplied,
                statementStatusIDs: this.getSelectedStatementStatusIDs,
                statements: this.getSelectedStatements,
                visitNphiesStatusIDs: this.SelectedNphiesStatusIds
            }

            console.log(obj, 'obj');
            if ((obj.SelectedStatementIds != null && obj.SelectedNphiesStatusIds != null) || (obj.BundleId != null)) {
                let res = this.getStatementsVisits(obj.SelectedStatementIds, obj.SelectedNphiesStatusIds, obj.BundleId,obj.ContractorStatementID);
                this.bulkActionsGridDS = res.data;
            }

            this.forceRerenderGrid();

        });
    },

    created() {
    },
    beforeDestroy() {
        $("body").off("click");
        GlobalEventBus.$off(`confirmed-action${this.suffix}`);
        GlobalEventBus.$off(`GetStatementsVisits`);

    },
    components: {
        ConfirmPopup: () => import("@/app/shared/components/confirm-popup/confirm-popup.vue"),
        Loader: () => import("@/app/shared/layouts/components/loader/loader.vue"),
        ViewHistorysModal: () => import("@/app/visit-management/modals/view-history-modal/view-history-modal.vue"),
        TransactionErrorListModal: () => import("@/app/visit-management/modals/transaction-error-list-modal/transaction-error-list-modal.vue"),
        SendClaimRequestNphies: () => import("@/app/visit-management/modals/send-claim-request-nphies/send-claim-request-nphies.vue"),
        cancelClaimRequest: () => import("@/app/visit-management/modals/cancel-claim-request/cancel-claim-request.vue"),

    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },

    }

}